"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.viewInitialMessage = exports.sendStartTyping = exports.sendPredifinedMessage = exports.sendMessage = exports.sendInitialMessage = exports.sendImage = exports.receiveMessages = exports.loadReceivedMessages = exports.hideMessages = exports.getNotificationType = exports.getMessagesHTTP = exports.getButtons = exports.addNotificationType = void 0;
var _uuid = require("uuid");
var _client = require("@apollo/client");
var _types = require("./types");
var _2 = require(".");
var _selectors = require("../selectors");
var _chatUtil = require("../helpers/chatUtil");
var _errorActions = require("./errorActions");
var _imageActions = require("./imageActions");
var _exceptions = require("../exceptions");
var _timeUtil = require("../helpers/timeUtil");
var _currentVersion = require("../helpers/currentVersion");
var _init = require("../helpers/apollo/init");
var _messageUtil = require("../helpers/messageUtil");
var _templateObject, _templateObject2, _templateObject3;
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var IMAGE_TYPE = 'image';
var START_TYPING_TYPE = 'typing';

// ====================================================================
// Typed actions
// ====================================================================

var loadReceivedMessages = exports.loadReceivedMessages = function loadReceivedMessages(messages) {
  return {
    type: _types.RECEIVE_MESSAGES,
    value: {
      messages: messages
    }
  };
};
var hideMessages = exports.hideMessages = function hideMessages(messages) {
  return {
    type: _types.HIDE_MESSAGES,
    value: {
      messages: messages
    }
  };
};
var addNotificationType = exports.addNotificationType = function addNotificationType(idMessage, notificationType, roomname) {
  return {
    type: _types.ADD_NOTIFICATION_TYPE,
    value: {
      idMessage: idMessage,
      notificationType: notificationType,
      roomname: roomname
    }
  };
};

// ====================================================================
// Functions actions
// ====================================================================

function hasAlreadySoldMessage(message) {
  return message.toLowerCase().replace('á', 'a').includes('ja vendi');
}
function handleAlreadySoldTip(dispatch, getState, message, Lurker) {
  var state = getState();
  var isSeller = (0, _selectors.amISeller)(state);
  var chat = (0, _selectors.getCurrentChat)(state);
  var listId = chat.listId,
    roomname = chat.roomname;
  var isEligibleForAlreadySoldTip = isSeller && hasAlreadySoldMessage(message);
  if (isEligibleForAlreadySoldTip) {
    var alreadySoldMessage = {
      customType: 'sys_messaging/ALREADY_SOLD_TIP',
      id: (0, _uuid.v4)(),
      roomname: roomname,
      sender: 'sys_messaging',
      timestamp: (0, _timeUtil.curTimestamp)().toString(),
      version: 2,
      listId: listId
    };
    dispatch(loadReceivedMessages([alreadySoldMessage]));
    Lurker.showAlreadySoldTip();
  }
}
var viewInitialMessage = exports.viewInitialMessage = function viewInitialMessage() {
  return function (dispatch, getState, _ref) {
    var Lurker = _ref.Lurker;
    Lurker.viewInitialMessage();
  };
};
var sendMessage = exports.sendMessage = function sendMessage(textMessage) {
  var custom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isInitialMessage = arguments.length > 2 ? arguments[2] : undefined;
  return function (dispatch, getState, _ref2) {
    var ChatSDK = _ref2.ChatSDK,
      Lurker = _ref2.Lurker,
      DataLayer = _ref2.DataLayer,
      Tracker = _ref2.Tracker;
    var _custom$customType = custom.customType,
      customType = _custom$customType === void 0 ? null : _custom$customType,
      _custom$customId = custom.customId,
      customId = _custom$customId === void 0 ? null : _custom$customId;
    var state = getState();
    var chat = (0, _selectors.getCurrentChat)(state);
    var partnerId = (0, _chatUtil.getPartnerIdFromChat)(chat);
    var listId = chat.listId;
    var myFirstMessage = !(0, _selectors.hasMyMessages)(state);
    var _ref3 = (0, _selectors.getCurrentLastMessage)(state) || {},
      _ref3$sender = _ref3.sender,
      lastMessageBy = _ref3$sender === void 0 ? '' : _ref3$sender;
    var roomname = (0, _selectors.getCurrentRoomname)(state);
    var amIBuyer = !(0, _selectors.amISeller)(state);
    var activeTab = (0, _selectors.activeChatTab)(state);
    var isFavorite = activeTab === '2';
    var beforeSendMessageCb = function beforeSendMessageCb(_roomname, messageId) {
      Lurker.clickSendMessage(messageId, isFavorite);
      dispatch(handleSendMessageByType(customType, textMessage, messageId));
    };
    return ChatSDK.sendMessage(roomname, textMessage, beforeSendMessageCb, customType, _currentVersion.versionWithPlatform).then(function (_ref4) {
      var messageId = _ref4.id,
        currentMessageTimestamp = _ref4.timestamp;
      DataLayer.sentMessageSuccesfull();
      Lurker.viewSendMessageSuccessful(messageId, isFavorite);
      dispatch(handleSendMessageSuccessfulByType(customType, customId, messageId));
      var username = chat.username;
      var lastMessageIsNotMine = username !== lastMessageBy;
      handleAlreadySoldTip(dispatch, getState, textMessage, Lurker);
      if (lastMessageIsNotMine && lastMessageBy !== '') {
        var lastMessageTimestamp = (0, _selectors.lastPartnerMessageTimestamp)(state);
        var timeDiffInMs = Math.round((currentMessageTimestamp - lastMessageTimestamp) / 1000);
        Lurker.viewReplyChat(messageId, timeDiffInMs, amIBuyer, isFavorite);
        if (myFirstMessage) {
          Lurker.viewReplyChatFirstTime(messageId, timeDiffInMs, isFavorite);
        }
      } else if (myFirstMessage && amIBuyer) {
        DataLayer.replyChatFirstTime();
        Lurker.viewSendBuyerFirstMessageSuccessful(messageId, isInitialMessage);
        Tracker.replyChat(listId);
      }
      return chat;
    })["catch"](function (ex) {
      var message = ex.message,
        _ex$sentMessage = ex.sentMessage,
        sentMessage = _ex$sentMessage === void 0 ? {} : _ex$sentMessage;
      var messageId = sentMessage.id;
      switch (message) {
        case 'RECEIVER_IS_BANNED':
          dispatch((0, _2.bannUser)(partnerId));
          Lurker.viewSendMessageSuccessful(messageId, isFavorite);
          dispatch(handleSendMessageSuccessfulByType(customType, customId, messageId));
          Lurker.viewSendMessageToBannedUser(messageId);
          break;
        case 'RECEIVER_IS_BLOCKED':
          dispatch((0, _2.blockUser)(partnerId));
          Lurker.viewSendMessageSuccessful(messageId, isFavorite);
          dispatch(handleSendMessageSuccessfulByType(customType, customId, messageId));
          Lurker.viewSendMessageToBlockedUser(messageId);
          break;
        case 'RECEIVER_IS_BLOCKED_BY_DENOUNCE':
          dispatch((0, _2.denounceUser)(partnerId));
          Lurker.viewSendMessageSuccessful(messageId, isFavorite);
          dispatch(handleSendMessageSuccessfulByType(customType, customId, messageId));
          Lurker.viewSendMessageToBlockedUser(messageId);
          break;
        case 'NO_INTERNET':
          Lurker.viewSendMessageSuccessful(messageId, isFavorite);
          dispatch(handleSendMessageSuccessfulByType(customType, customId, messageId));
          Lurker.viewSendMessageWithNoInternet(messageId);
          break;
        default:
          Lurker.viewSendMessageFailure(messageId, ex, isFavorite);
          dispatch(handleSendMessageFailureByType(customType, customId, messageId, ex));
          dispatch((0, _errorActions.handleError)(new _exceptions.SendMessageException(ex)));
      }
      return ex;
    });
  };
};
var receiveMessages = exports.receiveMessages = function receiveMessages(messages) {
  return function (dispatch, getState) {
    if (!messages || messages.length === 0) return;
    var state = getState();
    var chatsByRoomName = state.chatsByRoomName,
      renderProps = state.renderProps;
    var currentRoomname = (0, _selectors.getCurrentRoomname)(state);
    var lastMessage = messages[messages.length - 1];
    var _ref5 = lastMessage || {},
      roomname = _ref5.roomname;
    dispatch(loadReceivedMessages(messages));
    if (roomname === currentRoomname) {
      dispatch((0, _2.updateLastSeen)());
    }
    var _renderProps$listId = renderProps.listId,
      listId = _renderProps$listId === void 0 ? '' : _renderProps$listId;
    if (!listId && roomname && !(roomname in chatsByRoomName)) {
      dispatch((0, _2.getChat)(roomname));
    }
  };
};
var sendPredifinedMessage = exports.sendPredifinedMessage = function sendPredifinedMessage(textMessage) {
  return function (dispatch, getState, _ref6) {
    var Lurker = _ref6.Lurker;
    var state = getState();
    var activeTab = (0, _selectors.activeChatTab)(state);
    var isFavorite = activeTab === '2';
    Lurker.clickPreDefinedMessage(textMessage, isFavorite);
    dispatch(sendMessage(textMessage));
  };
};
var sendInitialMessage = exports.sendInitialMessage = function sendInitialMessage() {
  return function (dispatch, getState, _ref7) {
    var Lurker = _ref7.Lurker;
    var _getInitialMessage = (0, _selectors.getInitialMessage)(getState()),
      initialMessage = _getInitialMessage.initialMessage,
      sendInitialMessageDirectly = _getInitialMessage.sendInitialMessageDirectly;
    if (initialMessage) {
      Lurker.clickInitialPreDefinedMessage(initialMessage);
      if (sendInitialMessageDirectly) {
        dispatch(sendMessage(initialMessage));
        dispatch((0, _2.cleanInitialMessage)());
      }
    }
  };
};
var sendImage = exports.sendImage = function sendImage(url, imageId) {
  return function (dispatch) {
    dispatch(sendMessage(url, {
      customType: IMAGE_TYPE,
      customId: imageId
    }));
  };
};
var sendStartTyping = exports.sendStartTyping = function sendStartTyping() {
  return function (dispatch, getState, _ref8) {
    var ChatSDK = _ref8.ChatSDK;
    var beforeSendCb = function beforeSendCb() {};
    ChatSDK.sendMessage((0, _selectors.getCurrentRoomname)(getState()), '', beforeSendCb, START_TYPING_TYPE)["catch"](function (ex) {
      if (ex.message !== 'NO_INTERNET') {
        dispatch((0, _errorActions.handleError)(new _exceptions.SendMessageException(ex)));
      }
    });
  };
};

// ====================================================================
// Helper functions
// ====================================================================
var handleSendMessageByType = function handleSendMessageByType(customType, textMessage, messageId) {
  return function (_, __, _ref9) {
    var Lurker = _ref9.Lurker;
    switch (customType) {
      case IMAGE_TYPE:
        Lurker.clickSendImage(textMessage, messageId);
        break;
      default:
      // do nothing
    }
  };
};
var handleSendMessageSuccessfulByType = function handleSendMessageSuccessfulByType(customType, customId, messageId) {
  return function (dispatch, getState, _ref10) {
    var Lurker = _ref10.Lurker;
    var state = getState();
    var activeTab = (0, _selectors.activeChatTab)(state);
    var isFavorite = activeTab === '2';
    var roomname = (0, _selectors.getCurrentRoomname)(state);
    switch (customType) {
      case IMAGE_TYPE:
        Lurker.viewSendImageSuccessful(messageId, isFavorite);
        dispatch((0, _imageActions.imageLoadingSuccessful)(customId, roomname));
        break;
      default:
      // do nothing
    }
  };
};
var handleSendMessageFailureByType = function handleSendMessageFailureByType(customType, customId, messageId, ex) {
  return function (dispatch, getState, _ref11) {
    var Lurker = _ref11.Lurker;
    var roomname = (0, _selectors.getCurrentRoomname)(getState());
    switch (customType) {
      case IMAGE_TYPE:
        Lurker.viewSendImageFailure(messageId, ex);
        dispatch((0, _imageActions.imageLoadingFailed)(customId, roomname));
        break;
      default:
      // do nothing
    }
  };
};
var getButtons = exports.getButtons = function getButtons(roomname, olxPayState) {
  return function (dispatch) {
    var client = (0, _init.initApollo)();
    client.query({
      query: (0, _client.gql)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        query Messages($roomname: String, $olxPayState: String) {\n          messages(roomname: $roomname) {\n            buttons(olxPayState: $olxPayState) {\n            primary {\n              url\n              title\n              icon\n              objectDetails\n              modal {\n                type\n                makeOfferData {\n                  minValue\n                }\n                reviewOfferData {\n                  price\n                  serviceFee\n                  serviceFeeValue\n                  offeredPrice\n                  finalValue\n                  offerId\n                }\n                closeDisputeData {\n                  disputeId\n                  buyerOptions {\n                    label\n                    value\n                    url\n                  }\n                }\n              }\n            }\n            secondary {\n              url\n              title\n              icon\n              objectDetails\n              modal {\n                type\n                makeOfferData {\n                  minValue\n                }\n                reviewOfferData {\n                  price\n                  serviceFee\n                  serviceFeeValue\n                  offeredPrice\n                  finalValue\n                  offerId\n                }\n                closeDisputeData {\n                  disputeId\n                  buyerOptions {\n                    label\n                    value\n                    url\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    "]))),
      variables: {
        roomname: roomname,
        olxPayState: olxPayState
      },
      fetchPolicy: 'network-only'
    }).then(function (_ref12) {
      var _data$messages;
      var data = _ref12.data,
        errors = _ref12.errors;
      if (errors || !data) {
        throw new Error('QUERY_ERROR');
      }
      dispatch((0, _2.addButtons)(roomname, data === null || data === void 0 || (_data$messages = data.messages) === null || _data$messages === void 0 ? void 0 : _data$messages.buttons));
    })["catch"](function (ex) {
      dispatch((0, _errorActions.handleError)(new _exceptions.JoinRoomException(ex)));
    });
  };
};
var getMessagesHTTP = exports.getMessagesHTTP = function getMessagesHTTP(roomname) {
  return function (dispatch, getState, _ref13) {
    var Lurker = _ref13.Lurker;
    dispatch((0, _2.joinRoomStart)());
    var client = (0, _init.initApollo)();
    var maxTimestamp = Number.parseInt((0, _selectors.getMaxTimestampByRoomName)(getState(), roomname));
    var chat = (0, _selectors.getChatByRoomName)(getState(), roomname);
    var currentChatPosition = (0, _selectors.getCurrentChatPosition)(getState());
    var _extractInfo = (0, _2.extractInfo)(chat),
      partner = _extractInfo.partner;
    var BANNED = _types.PARTNERS_STATUS.BANNED,
      BLOCKED = _types.PARTNERS_STATUS.BLOCKED,
      DENOUNCED = _types.PARTNERS_STATUS.DENOUNCED,
      VALIDATING_PROFILE = _types.PARTNERS_STATUS.VALIDATING_PROFILE;
    var activeTab = (0, _selectors.activeChatTab)(getState());
    var isFavorite = activeTab === '2';
    var startTime = (0, _timeUtil.monotonicNow)();
    client.query({
      query: (0, _client.gql)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      query GetMessages (\n          $roomname: String $after: DateTime $olxPayState: String\n        ) {\n        serverTimestamp\n        messages(\n            roomname: $roomname after: $after\n          ) {\n          data {\n            id\n            roomname\n            originalTimestamp\n            sender\n            text\n            textMasks {\n              start\n              end\n              textContent\n              textLink\n              lurkerObjectDetail\n            }\n            status\n            customType\n            notificationData\n            source\n            version\n            tip\n            notificationType{\n              name\n              tokens\n              componentId\n            }\n          }\n          partnerValidation\n          partner{\n            slug\n            facematch\n            name\n          }\n          buttons(olxPayState: $olxPayState) {\n            primary {\n              url\n              title\n              icon\n              objectDetails\n              modal {\n                type\n                makeOfferData {\n                  minValue\n                }\n                reviewOfferData {\n                  price\n                  serviceFee\n                  serviceFeeValue\n                  offeredPrice\n                  finalValue\n                  offerId\n                }\n                closeDisputeData {\n                  disputeId\n                  buyerOptions {\n                    label\n                    value\n                    url\n                  }\n                }\n              }\n            }\n            secondary {\n              url\n              title\n              icon\n              objectDetails\n              modal {\n                type\n                makeOfferData {\n                  minValue\n                }\n                reviewOfferData {\n                  price\n                  serviceFee\n                  serviceFeeValue\n                  offeredPrice\n                  finalValue\n                  offerId\n                }\n                closeDisputeData {\n                  disputeId\n                  buyerOptions {\n                    label\n                    value\n                    url\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    "]))),
      variables: {
        roomname: roomname,
        olxPayState: chat.olxPay,
        after: isNaN(maxTimestamp) ? null : new Date(maxTimestamp / 1000).toISOString()
      },
      fetchPolicy: 'network-only'
    }).then(function (_ref14) {
      var _data$messages$data;
      var data = _ref14.data,
        errors = _ref14.errors;
      if (errors || !data) {
        throw new Error('QUERY_ERROR');
      }
      if (!data.messages) {
        return;
      }
      var microsecondDiff = (0, _timeUtil.monotonicDiff)(startTime);
      Lurker.viewOpenChatMessagesSuccessful(microsecondDiff, currentChatPosition, isFavorite);
      switch (data.messages.partnerValidation) {
        case 'USER_IS_BANNED':
          dispatch((0, _2.joinRoomDone)(chat, _objectSpread(_objectSpread({}, partner), {}, {
            status: BANNED
          })));
          Lurker.viewOpenChatMessagesWithBannedUser();
          break;
        case 'USER_IS_BLOCKED':
          dispatch((0, _2.joinRoomDone)(chat, _objectSpread(_objectSpread({}, partner), {}, {
            status: BLOCKED
          })));
          Lurker.viewOpenChatMessagesWithBlockedUser();
          break;
        case 'USER_IS_VALIDATING_PROFILE':
          dispatch((0, _2.joinRoomDone)(chat, _objectSpread(_objectSpread({}, partner), {}, {
            status: VALIDATING_PROFILE
          })));
          Lurker.viewOpenChatWithValidatingProfileUser();
          break;
        case 'USER_IS_BLOCKED_BY_DENOUNCE':
          dispatch((0, _2.joinRoomDone)(chat, _objectSpread(_objectSpread({}, partner), {}, {
            status: DENOUNCED
          })));
          Lurker.viewOpenChatMessagesWithBlockedUser();
          break;
        default:
          break;
      }
      var messages = (0, _messageUtil.parseMessages)((_data$messages$data = data.messages.data) !== null && _data$messages$data !== void 0 ? _data$messages$data : [], data.serverTimestamp);
      var slug = data.messages.partner.slug;
      var facematch = data.messages.partner.facematch;
      var name = data.messages.partner.name;
      var buttons = data.messages.buttons;
      dispatch(receiveMessages(messages, true));
      dispatch((0, _2.updatePartner)(roomname, slug, facematch, name));
      dispatch((0, _2.updateChatMessagesLoaded)(roomname));
      dispatch((0, _2.loadChat)());
      dispatch((0, _2.addButtons)(roomname, buttons));
    })["catch"](function (ex) {
      if (!maxTimestamp) {
        dispatch((0, _errorActions.handleError)(new _exceptions.JoinRoomException(ex)));
      }
    });
  };
};
var getNotificationType = exports.getNotificationType = function getNotificationType(messageId, roomname, name) {
  return function (dispatch) {
    var client = (0, _init.initApollo)();
    client.query({
      query: (0, _client.gql)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      query GetComponent($name: String!) {\n        notificationType(name: $name) {\n          name\n          tokens\n          componentId\n        }\n      }\n      "]))),
      variables: {
        name: name
      },
      fetchPolicy: 'network-only'
    }).then(function (_ref15) {
      var data = _ref15.data,
        errors = _ref15.errors;
      if (errors || !data) {
        throw new Error('QUERY_ERROR');
      }
      var notificationType = data.notificationType;
      if (notificationType) {
        dispatch(addNotificationType(messageId, notificationType, roomname));
      }
    })["catch"](function (ex) {
      // do nothing
    });
  };
};